export const PersonTypeOptions = { F: 'Pessoa fisica', J: 'Pessoa juridica' };
export const PersonDocumentTypeOptions = { F: 'CPF', J: 'CNPJ' };

export default PersonTypeOptions;
